<template>
  <div>
    <b-row>
      <b-col cols="4">
        <Tracker />
      </b-col>
      <b-col cols="8">
        <GraficoMensal />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <cards
          ref="totais"
          :select-card="loadCard"
          :contadores="contadores"
          :update-propostas="updatePropostas"
          :update-acordos="countAcordos"
          :update-lista="listarRetiradaNegativacao"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="card === 0">
        <b-card title="Baixa Administrativa">
          <BaixaAdminstrativa
            :itemsbaixa="itemsBaixas"
          />
        </b-card>
      </b-col>
      <b-col v-if="card === 1">
        <b-card title="Retirar Negativação">
          <RetirarNegativacao
            :itemsretirar="itemsRetiradaNegativacao"
          />
        </b-card>
      </b-col>
      <b-col v-if="card === 2">
        <b-card title="Percentual">
          <Percentual />
        </b-card>
      </b-col>
      <b-col v-if="card === 3">
        <b-card title="Boletos Liquidados">
          <BoletosLiquidados />
        </b-card>
      </b-col>
      <b-col v-if="card === 4">
        <b-card title="Protestos">
          <Protestos
            ref="protestos"
            :update-contador="updateProtestos"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import axios from '@/../axios-auth'
import GraficoMensal from '@components/Graficos/GraficoMensal.vue'
import Tracker from '@components/Graficos/Tracker.vue'
import Cards from './components/Cards.vue'
import BaixaAdminstrativa from './components/BaixaAdm.vue'
import RetirarNegativacao from './components/RetirarNegativacao.vue'
import Protestos from './components/Protestos.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    Cards,
    BaixaAdminstrativa,
    RetirarNegativacao,
    GraficoMensal,
    Tracker,
    Protestos,
  },
  data() {
    return {
      itemsBaixas: [],
      itemsRetiradaNegativacao: [],
      dueDate: {
        start: '',
        end: '',
      },
      card: '',
    }
  },
  created() {
    this.countAcordos()
    this.listarRetiradaNegativacao()
    this.updateProtestos()
  },
  methods: {
    async countAcordos() {
      await axios.get('api/v1/acordo/baixa_admin', {
        headers: {
          Accept: 'Application/json',
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        },
      }).then(res => {
        const totalBaixa = []
        res.data.dados.map(item => {
          totalBaixa.push(item)
        })
        this.itemsBaixas = totalBaixa
        this.$refs.totais.updateAcordos(totalBaixa.length)
      })
    },

    loadCard(data) {
      if (this.card === data) {
        this.card = null
      }
      this.card = data
    },

    async listarRetiradaNegativacao() {
      await axios.get('api/v1/operacoes/listar/retirar/negativacao', {
        headers: {
          Accept: 'Application/json',
          Authorization: 'Bearer '.concat(localStorage.getItem('token')),
        },
      })
        .then(res => {
          const devolucoesExcluidas = [22]
          const totalListaRetiradaNegativacao = []
          res.data.dados.map(item => {
            if (!devolucoesExcluidas.includes(item.motivo_devolucao_id)) {
              totalListaRetiradaNegativacao.push(item)
            }
          })
          this.itemsRetiradaNegativacao = totalListaRetiradaNegativacao
          this.$refs.totais.updateLista(totalListaRetiradaNegativacao.length)
        })
    },

    async updateProtestos() {
      if (this.$refs.protestos) {
        await this.$refs.protestos.getAcordos()
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
